export default "__VITE_ASSET__DCIyBn_G__"